import { Route } from '@angular/router';
import { InsuranceTypesListComponent } from './ui/insurance-types-list/insurance-types-list.component';
import { InsuranceTypeFormComponent } from './ui/insurance-type-form/insurance-type-form.component';
import { planAuthorGuard } from '../../core/guards/plan-author.guard';
import { planViewerGuard } from '../../core/guards/plan-viewer.guard';

const insuranceTypesRoutes: Route[] = [
    {
        path: 'insurance-types',
        component: InsuranceTypesListComponent,
    },
    {
        path: 'insurance-types/new',
        component: InsuranceTypeFormComponent,
        canActivate: [planAuthorGuard],
    },
    {
        // Viewers included: the form renders read-only for regional users
        path: 'insurance-types/:id/edit',
        component: InsuranceTypeFormComponent,
        canActivate: [planViewerGuard],
    },
];

export default insuranceTypesRoutes;
